import React, { useState } from "react";

const isValidNoteInput = (v) => v === "" || /^\d{0,2}([.,]\d{0,2})?$/.test(v);
const clampNote = (v) => {
  if (v === "") return "";
  const n = parseFloat(String(v).replace(",", "."));
  if (isNaN(n)) return v;
  if (n > 20) return "20";
  if (n < 0) return "0";
  return v;
};

const Snote = ({
  note,
  changeNote,
  subjectIndex,
  unitInedx,
  changeNoteEdge,
  min,
  max,
  noteRef,
}) => {
  const [isClamped, setIsClamped] = useState(false);

  return (
    <>
      <td
        style={{
          border: "1px solid #e5e7eb",
          backgroundColor: "#ffffff",
          boxSizing: "border-box",
          padding: 1,
        }}
      >
        <input
          ref={noteRef}
          className={`form-control${isClamped ? " clamped" : ""}`}
          style={{
            height: "100%",
            textAlign: "center",
            borderRadius: 0,
            fontSize: 17,
            fontWeight: 700,
          }}
          type="text"
          inputMode="decimal"
          placeholder="—"
          aria-label="Note élève"
          title={isClamped ? "Valeur limitée à 20 (max)" : undefined}
          value={note ?? ""}
          onChange={(e) => {
            const v = e.target.value;
            if (!isValidNoteInput(v)) return;
            const n = parseFloat(String(v).replace(",", "."));
            if (!isNaN(n)) {
              setIsClamped(n > 20);
            }
            changeNote(unitInedx, subjectIndex, clampNote(v));
          }}
        />
      </td>
      <td
        style={{
          border: "1px solid #e5e7eb",
          backgroundColor: "#ffffff",
          boxSizing: "border-box",
          padding: 1,
        }}
      >
        <input
          className="form-control readonly-stat"
          style={{
            height: "100%",
            textAlign: "center",
            borderRadius: 0,
            fontSize: 17,
            fontWeight: 700,
          }}
          type="text"
          inputMode="decimal"
          placeholder="—"
          aria-label="Min classe"
          readOnly={true}
          tabIndex={-1}
          value={min ?? ""}
          onChange={(e) => {
            const v = e.target.value;
            if (!isValidNoteInput(v)) return;
            changeNoteEdge(unitInedx, subjectIndex, clampNote(v), "min");
          }}
        />
      </td>
      <td
        style={{
          border: "1px solid #e5e7eb",
          backgroundColor: "#ffffff",
          boxSizing: "border-box",
          padding: 1,
        }}
      >
        <input
          className="form-control readonly-stat"
          style={{
            height: "100%",
            textAlign: "center",
            borderRadius: 0,
            fontSize: 17,
            fontWeight: 700,
          }}
          type="text"
          inputMode="decimal"
          placeholder="—"
          aria-label="Max classe"
          readOnly={true}
          tabIndex={-1}
          value={max ?? ""}
          onChange={(e) => {
            const v = e.target.value;
            if (!isValidNoteInput(v)) return;
            changeNoteEdge(unitInedx, subjectIndex, clampNote(v), "max");
          }}
        />
      </td>
    </>
  );
};

export default Snote;
